module.exports = __webpack_public_path__ + "static/media/identity-mapping.7e8c3ee5.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/identity-mapping.md
// module id = 1100
// module chunks = 0